export const SEARCH_AUTOCOMPLETE_CATEGORY_TREE_SET = 'SEARCH_AUTOCOMPLETE_CATEGORY_TREE_SET';
